var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCursor = function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8750D7",
    d: "M11.393 8.485H8.484v2.91h-.97v-2.91H4.606v-.97h2.91V4.606h.97v2.91h2.908z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "#8750D7"
  })));
};
export { SvgCursor as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Ik0xMS4zOTMzIDguNDg0OTlIOC40ODQyNlYxMS4zOTQxSDcuNTE0NTZWOC40ODQ5OUg0LjYwNTQ3VjcuNTE1MjlINy41MTQ1NlY0LjYwNjJIOC40ODQyNlY3LjUxNTI5SDExLjM5MzNWOC40ODQ5OVoiIGZpbGw9IiM4NzUwRDciLz4KCTxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2U9IiM4NzUwRDciIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4K";